import React from 'react';

import { Button, Col, Image, Row, Space, Typography } from 'antd';

import { AgGridReact } from 'ag-grid-react';

import {
  EnhancedMarkdown,
  FormCancelButton,
  FormSaveButton,
  StyledModal,
  WithLoading,
} from 'common/components';

import { useVisibleModal } from 'hooks';
import { useGetUserEulaCard } from './hooks';

import rivirLogo from 'assets/VAULT_LOGO_BLACK.png';
// import dataCouncilLogo from 'assets/data-council.png';

import { modalBodyProductActiveHeight } from './constants';

export const IXOneHeader = (props) => {
  return (
    <Row align='middle' justify='space-between' {...props}>
      <Col>
        <Image width={200} src={rivirLogo} preview={false} />
      </Col>
      {/* <Col>
        <Image width={240} src={dataCouncilLogo} preview={false} />
      </Col> */}
    </Row>
  );
};

export const IXOneMessage = (props) => {
  return (
    <Typography.Text
      strong
      style={{
        fontSize: 14,
      }}
      {...props}
    >
      Please confirm your selection to have the following products made Public
      and accessible to Retail Members of VAULT
    </Typography.Text>
  );
};

export const IXOneGrid = React.forwardRef((props, ref) => {
  const { columns, productList, style, children, ...otherProps } = props;

  return (
    <>
      <div
        style={{ height: 300, paddingTop: 12, ...style }}
        className='make-product-active__ixone-grid'
      >
        <div
          span={24}
          className='ag-theme-alpine ag-theme-alpine--with-scroller'
          style={{ width: '100%', height: '100%' }}
        >
          <AgGridReact
            columnDefs={columns}
            rowData={productList}
            headerHeight={32}
            rowHeight={34}
            rowSelection={'single'}
            defaultColDef={{
              sortable: false,
              resizable: true,
              filter: false,
            }}
            overlayNoRowsTemplate='No Rows to Show'
            ref={ref}
            {...otherProps}
          />
        </div>
      </div>
      {children}
    </>
  );
});

export const IXOneTotalFee = ({ fee }) => {
  const formattedFee = Number(fee).toFixed(2);

  return (
    <div style={{ paddingRight: 16, paddingTop: 8, textAlign: 'right' }}>
      <Typography.Text strong style={{ fontSize: 14, paddingRight: 4 }}>
        Total Fee:
      </Typography.Text>
      <Typography.Text strong style={{ fontSize: 16, fontWeight: 700 }}>
        {formattedFee}$
      </Typography.Text>
    </div>
  );
};

export const IXOneFooter = ({ onCancel, onSave, loading, disabled }) => {
  const [visibleReviewBilling, { onModal, offModal }] = useVisibleModal();

  return (
    <>
      <Row align='middle' justify='space-between' style={{ paddingTop: 8 }}>
        <Col>
          <Button
            type='link'
            style={{ paddingLeft: 0, textDecoration: 'underline' }}
            onClick={onModal}
          >
            <Typography.Text
              style={{ textDecoration: 'underline', color: '#238dd9' }}
            >
              Review the VAULT Billing T&Cs
            </Typography.Text>
          </Button>
        </Col>
        <Col>
          <Space>
            <FormCancelButton onClick={onCancel} />
            <FormSaveButton
              text='Confirm Request'
              loading={loading}
              disabled={disabled}
              onClick={onSave}
            />
          </Space>
        </Col>
      </Row>

      {visibleReviewBilling && (
        <RIVIRBillingReview
          visible={visibleReviewBilling}
          onCancel={offModal}
        />
      )}
    </>
  );
};

export const RIVIRBillingReview = (props) => {
  const { eulaContent, isLoading } = useGetUserEulaCard();

  const modalProps = {
    title: 'Credit Card Terms & Conditions',
    destroyOnClose: true,
    width: 1200,
    bodyStyle: modalBodyProductActiveHeight,
    footer: null,
    ...props,
  };

  return (
    <StyledModal {...modalProps}>
      <WithLoading loading={isLoading}>
        <EnhancedMarkdown source={eulaContent} />
      </WithLoading>
    </StyledModal>
  );
};

export const IXOneGridHierarchy = ({ value, children }) => {
  return (
    <Space
      align='center'
      style={{ width: '100%', justifyContent: 'space-between' }}
    >
      <Typography.Text>{value}</Typography.Text>
      {children}
    </Space>
  );
};
